import { render, staticRenderFns } from "./NotesListDialog.vue?vue&type=template&id=35a1ed9e&scoped=true"
import script from "./NotesListDialog.vue?vue&type=script&lang=ts"
export * from "./NotesListDialog.vue?vue&type=script&lang=ts"
import style0 from "./NotesListDialog.vue?vue&type=style&index=0&id=35a1ed9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a1ed9e",
  null
  
)

export default component.exports